import React from 'react';
import { Table } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import NoAttachmentsRow from './NoAttachmentsRow';
import DatasetStorageErrorRow from '../../components/DatasetStorageErrorRow';
import DatasetAttachmentRows from './DatasetAttachmentRows';
import Selectors from '../hooks/selectors';

const DatasetAttachmentsTableBody = ({
  category,
  code,
  columns,
  items,
}) => {
  const {
    error, readStatus, readError, storageEnabled,
  } = Selectors.useDatasetAttachmentsTableBody({ category, code });
  const noItems = items.length === 0 && !error && storageEnabled && readStatus !== states.PENDING;

  return (
    <Table.Body className="aridhia-dataset-attachments-table-body">
      {(error || readError || !storageEnabled) && (
        <DatasetStorageErrorRow
          colSpan={columns.length}
          error={error || readError}
        />
      )}
      {noItems && <NoAttachmentsRow />}
      <DatasetAttachmentRows category={category} code={code} columns={columns} items={items} />
    </Table.Body>
  );
};

export default DatasetAttachmentsTableBody;
